import { render, staticRenderFns } from "./HeaderBottomUserNotification.vue?vue&type=template&id=67113aea&"
import script from "./HeaderBottomUserNotification.vue?vue&type=script&lang=ts&"
export * from "./HeaderBottomUserNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports